import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import WaveGroup from "../specs/groups/group/WaveGroup";
import { WaveGroupType } from "../specs/groups/group/WaveGroup.types";
interface WaveGroupsProps {
  readonly wave: ApiWave;
  readonly useRing?: boolean;
}
export default function WaveGroups(t0) {
  const $ = _c(15);
  const {
    wave,
    useRing: t1
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const ringClasses = useRing ? "tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-rounded-xl" : "tw-rounded-b-xl lg:tw-rounded-b-none";
  const t2 = `tw-h-full tw-bg-iron-950 tw-relative ${ringClasses}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-px-4 tw-pt-4 tw-flex tw-justify-between tw-items-start tw-gap-x-6"><p className="tw-mb-0 tw-text-base tw-text-iron-200 tw-font-semibold tw-tracking-tight">Eligible</p></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  let t5;
  if ($[1] !== wave) {
    t4 = <WaveGroup scope={wave.visibility.scope} type={WaveGroupType.VIEW} isEligible={true} wave={wave} />;
    t5 = wave.wave.type !== ApiWaveType.Chat && <><WaveGroup scope={wave.participation.scope} type={WaveGroupType.DROP} isEligible={wave.participation.authenticated_user_eligible} wave={wave} /><WaveGroup scope={wave.voting.scope} type={WaveGroupType.VOTE} isEligible={wave.voting.authenticated_user_eligible} wave={wave} /></>;
    $[1] = wave;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  let t7;
  if ($[4] !== wave) {
    t6 = <WaveGroup scope={wave.chat.scope} type={WaveGroupType.CHAT} isEligible={wave.chat.authenticated_user_eligible} wave={wave} />;
    t7 = <WaveGroup scope={wave.wave.admin_group} type={WaveGroupType.ADMIN} isEligible={wave.wave.authenticated_user_eligible_for_admin} wave={wave} />;
    $[4] = wave;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <div className="tw-h-full tw-overflow-y-auto tw-overflow-x-hidden no-scrollbar"><div className="tw-pb-4">{t3}<div className="tw-px-4 tw-flex tw-flex-col tw-gap-y-2 tw-mt-2">{t4}{t5}{t6}{t7}</div></div></div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t8) {
    t9 = <div className="tw-border-t tw-border-iron-800 tw-border-solid tw-border-x-0 tw-border-b-0"><div className={t2}>{t8}</div></div>;
    $[12] = t2;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}